import { render } from "./EditHoliday.vue?vue&type=template&id=83cf9abc&scoped=true"
import script from "./EditHoliday.vue?vue&type=script&lang=js"
export * from "./EditHoliday.vue?vue&type=script&lang=js"

import "./holiday.scss?vue&type=style&index=0&id=83cf9abc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83cf9abc"]])

export default __exports__